import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.pexels.com/photos/20464241/pexels-photo-20464241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#2D3142]/60 via-transparent to-transparent" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <p className="text-xs uppercase tracking-[0.2em] opacity-80">Bloom</p>
          <p className="font-display text-3xl mt-2 leading-tight">Return to your own quiet pace.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10" data-testid="login-logo">
            <div className="w-8 h-8 rounded-full bg-[#E07A5F] flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-display font-semibold text-lg">Bloom</span>
          </Link>
          <h1 className="font-display text-4xl tracking-tight text-[#2D3142]">Welcome back.</h1>
          <p className="text-[#5b5f6e] mt-2">Sign in to your practice — your streaks & journal are waiting.</p>

          <button
            onClick={handleGoogle}
            className="mt-8 w-full flex items-center justify-center gap-3 bg-white border border-[#E5E3DF] rounded-full py-4 hover:border-[#2D3142] transition-colors"
            data-testid="google-signin-btn"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            <span className="font-medium text-[#2D3142]">Continue with Google</span>
          </button>

          <p className="text-xs text-[#8A8D98] mt-6 leading-relaxed">
            By continuing you agree to Bloom's gentle terms. We keep your journal private by default —
            you decide what to share with the community.
          </p>

          <Link to="/" className="mt-10 inline-block text-sm text-[#8A8D98] hover:text-[#E07A5F]" data-testid="back-home">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
